import * as React from 'react';
import { GridDayProps } from '../../components/grid/day';

import * as moment from 'moment';
import GridEventView from '../../components/grid/event';

const GridDayView: React.StatelessComponent<GridDayProps> = props => {
    const dateMoment = moment(props.day.date);
    const todayMoment = moment();
    const isDayInPast = dateMoment.isBefore(todayMoment, 'day');
    const isDayToday = dateMoment.isSame(todayMoment, 'day');
    return (
        <li className={`ace-cal-grid-day ${isDayInPast ? "is-past" : ""} ${isDayToday ? "is-today" : ""}`} aria-labelledby={`Day-${dateMoment.format("X")}`}>
            {
                props.day.events.length > 0 ?
                    <article className={`ace-cal-grid-day-content ${!isDayInPast && 'has-content'}`}>
                        
                        <h4 id={`Day-${dateMoment.format("X")}`} className="visually-hidden">
                            {
                                <span role="text">
                                    {`${dateMoment.format("dddd, MMMM")} ${dateMoment.format("D")}`}
                                    <span>{`: ${props.day.events.length} ${props.day.events.length > 2 ? props.text.eventsPluralString : props.text.eventSingleString}`}</span>
                                </span>
                            }
                        </h4>
                        <div className="ace-cal-grid-day-content-inner">
                            <ul className="ace-cal-grid-day-content-list">
                                {
                                    props.day.events.map(event => <GridEventView key={event.id} event={event} />)
                                }
                            </ul>
                            <span aria-hidden="true" role="presentation" className="ace-cal-grid-day-date">{dateMoment.format("DD")}</span>
                        </div>
                    </article>
                    :
                    <div className="ace-cal-grid-day-content">
                        <span className="ace-cal-grid-day-date" id={`Day-${dateMoment.format("X")}`} role="text"><span className="visually-hidden">{`${dateMoment.format("dddd, MMMM")} `}</span>{dateMoment.format("DD")}</span>
                    </div>
            }
        </li>
    );
}

export default GridDayView;